// whether the logged-in doctor has an active plan (stored with the user by the login page)
// admins never need one; a doctor without one only sees "Choose your plan"

export const hasStoredActivePlan = () => {
    try {
        return JSON.parse(localStorage.getItem('user'))?.user?.has_active_plan === true
    } catch (e) {
        return false
    }
}

export const setStoredActivePlan = (active) => {
    try {
        const stored = JSON.parse(localStorage.getItem('user'))
        if (stored?.user) {
            stored.user.has_active_plan = active
            localStorage.setItem('user', JSON.stringify(stored))
        }
    } catch (e) {
        // nothing stored: the next login fetches it again
    }
}
